<template>

<div class="item" v-bind:class="{'is-selectable': selectable, 'is-dark': dark, 'has-more': hasMore}">

    <div class="item-users">

        <core-avatar type="player" :tooltip="true" :tooltipName="true" :item="player" class="item-avatar" v-for="(player, index) in item.players" :key="index" v-on:click="onAvatarClick(player.slug)" />
    
    </div>

	<slot></slot>

	<core-rating v-if="rating" :value="rating" class="item-rating" />

	<div v-if="item[countFieldFinal] && !countPercent" class="item-count" v-fit>{{ item[countFieldFinal] | prettyNumber }}<small v-if="countText">{{ countText }}<template v-if="item.count !== 0">s</template></small></div>

	<core-progress :percent="item[countFieldFinal]" v-if="item[countFieldFinal] && countPercent" :dark="dark" /> 

	<div v-if="selectable" class="item-selectable"><i class="fa fa-caret-right"></i></div>

</div>

</template>

<script>

export default {

	props: ['item', 'countText', 'countField', 'max', 'countPercent', 'notLinked', 'selectable', 'rating', 'dark'],

	computed: {

        hasMore: function() {

            return (this.max) ? this.max < this.item.players.length : false

        },

		countFieldFinal: function() {

			return this.countField || 'count'

		},

		cantLink: function() {

			return !this.item.id

		}

	},

	methods: {

		onAvatarClick: function(slug) {

			this.$router.push({
				name: 'InsightsPlayer', 
				params: {
					player: slug
				}
			})

		}

	}

}

</script>

<style scoped>

.item {
	width: 100%;
	height: 64px;
	display: flex;
	padding: 8px 15px 8px 15px;
	flex-direction: row;
}

@media only screen and (max-width: 767px) {

	.item {
		padding: 8px 8px;
		height: auto;
	}

}

.item.has-more {
    height: auto;
    padding-bottom: 0px;
}

.item:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.item.is-dark:nth-child(odd) {
	background-color: rgba(255, 255, 255, 0.05);
}

.is-desktop .item.is-selectable:hover {
	cursor: pointer;
	background-color: #4881bb;
}

.is-desktop .item.is-dark.is-selectable:hover {
	background-color: rgba(0, 0, 0, 0.2);
}

.item-users {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
}

.item-game,
.item-avatar {
	width: 48px;
	height: 48px;
	flex-shrink: 0;
    margin-right: 8px;
}

.item.has-more .item-avatar {
    margin-bottom: 8px;
}

.item-game {
	margin-left: 8px;
}

.item-name {
	padding: 0px 8px;
	flex-grow: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.item-name-name {
	font-size: 16px;
    line-height: 16px;
    font-weight: 400;
    color: #333;
    overflow: hidden;
    display: block;
}

.item.is-dark .item-name-name {
	color: #fff;
}

@media only screen and (max-width: 767px) {

	.item-name-name {
		font-size: 14px;
	}

}

.is-desktop .item.is-selectable:hover .item-name-name {
	color: #fff;
}

.item-name-subtext {
	font-size: 11px;
	color: #666;
}

.item.is-dark .item-name-subtext {
	color: rgba(255, 255, 255, 0.75);
}

.is-desktop .item.is-selectable:hover .item-name-subtext {
	color: #fff;
}

.is-desktop .item-name a:hover {
	text-decoration: underline;
	cursor: pointer;
}

.item-selectable {
	line-height: 64px;
	width: 64px;
	text-align: center;
	position: absolute;
	right: 0px;
	top: 0px;
	font-size: 32px;
	opacity: 0.75;
}

.item.is-dark .item-selectable {
	color: #fff;
}

.is-desktop .item.is-selectable:hover .item-selectable {
	color: #fff;
	opacity: 1;
}

.item-rating {
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	line-height: 48px;
	font-size: 18px;
	font-weight: 400;
}

.item-count {
	height: 48px;
	width: 48px;
    flex-shrink: 0;
    font-size: 24px;
    font-weight: 400;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
}

.item-count:not(.is-percent) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
}

.item.is-dark .item-count {
	color: #fff;
}

@media only screen and (max-width: 767px) {

	.item-count {
		font-size: 18px;
	}

}

.item-count small {
	font-size: 11px;
	color: #666;
	display: block;
}

.item.is-dark .item-count small {
	color: rgba(255, 255, 255, 0.75);
}

</style>